import { toast } from "react-toastify";
import { compressImage } from "./compressImage";

const ImageCompressor = async (imageFile) => {
  if (!imageFile) return null;

  try {
    const compressedFile = await new Promise((resolve) => {
      compressImage(imageFile, (file) => resolve(file), 100, 0.7);
    });

    if (!compressedFile) {
      return null;
    }

    console.log(
      "Compressed file size:",
      (compressedFile.size / 1024).toFixed(2),
      "KB"
    );

    return new File([compressedFile], imageFile.name, {
      type: compressedFile.type || imageFile.type,
      lastModified: Date.now(),
    });
  } catch (error) {
    console.error("Error compressing image:", error);
    toast.error("Image file upload failed");
    return null;
  }
};


export default ImageCompressor
// const handleFileUpload = async (e, setFieldValue) => {
//   const imageFile = e.target.files[0];
//   const compressedImageFile = await compressImage(imageFile);
//   if (compressedImageFile) {
//     setFieldValue("primary_image", compressedImageFile);
//   }
// };

// const ImageCompressor = ({ setFieldValue }) => {
//   return (
//     <div>
//       <input type="file" accept="image/*" onChange={(e) => handleFileUpload(e, setFieldValue)} />
//     </div>
//   );
// };

// export default ImageCompressor;
